import { render, staticRenderFns } from "./IconScroller.vue?vue&type=template&id=d09d54a0&scoped=true"
import script from "./IconScroller.vue?vue&type=script&lang=js"
export * from "./IconScroller.vue?vue&type=script&lang=js"
import style0 from "./IconScroller.vue?vue&type=style&index=0&id=d09d54a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09d54a0",
  null
  
)

export default component.exports